import React, { useState, useRef } from 'react';

const OrientedImage = ({ src, alt, intendedW, intendedH, className, style, loading, ...rest }) => {
  const [rotated, setRotated] = useState(false);
  const imgRef = useRef(null);

  const handleLoad = () => {
    const img = imgRef.current;
    if (!img) return;
    const fileAR = img.naturalWidth / img.naturalHeight;
    const intAR = intendedW / intendedH;
    if ((fileAR > 1.15 && intAR < 0.87) || (fileAR < 0.87 && intAR > 1.15)) {
      setRotated(true);
    }
  };

  if (rotated) {
    // Wrapper handles rotation + positioning; img inside fills the wrapper
    return (
      <div
        style={{
          position: 'absolute',
          width: `${(intendedH / intendedW) * 100}%`,
          height: `${(intendedW / intendedH) * 100}%`,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) rotate(90deg)',
          overflow: 'hidden',
        }}
      >
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          onLoad={handleLoad}
          loading={loading}
          className={className || 'w-full h-full object-cover'}
          style={style}
          draggable={rest.draggable}
          data-testid={rest['data-testid']}
        />
      </div>
    );
  }

  return (
    <img
      ref={imgRef}
      src={src}
      alt={alt}
      onLoad={handleLoad}
      loading={loading}
      className={className || 'w-full h-full object-cover'}
      style={style}
      draggable={rest.draggable}
      data-testid={rest['data-testid']}
    />
  );
};

// Size format is Height × Width (e.g. "48 × 16" = 48 tall × 16 wide)
export const parseSizeDimensions = (sizeStr) => {
  const match = (sizeStr || '').match(/(\d+)\s*×\s*(\d+)/);
  if (!match) return { w: 1, h: 1 };
  return { w: parseInt(match[2], 10), h: parseInt(match[1], 10) };
};

export default OrientedImage;
